import React from 'react';

import { Choice } from './index.js'

export const List = (props) => <Choice multiple={true} {...props} />
